import React from "react";
import { FiArrowUpRight, FiAward } from "react-icons/fi";
import { useLanguage } from "../../context/LanguageContext";

const certifications = [
  {
    year: "2026",
    title: "Belajar Back-End Pemula dengan JavaScript",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Feb 2026", id: "Feb 2026" },
    expires: { en: "Expires Feb 2029", id: "Berlaku hingga Feb 2029" },
    credential: "2VX358D03PYQ",
    credentialUrl: "https://www.dicoding.com/certificates/2VX358D03PYQ",
  },
  {
    year: "2026",
    title: "Prompt Engineering untuk Software Developer",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Jan 2026", id: "Jan 2026" },
    expires: { en: "Expires Jan 2029", id: "Berlaku hingga Jan 2029" },
    credential: "53XEK6N1KXRN",
    credentialUrl: "https://www.dicoding.com/certificates/53XEK6N1KXRN",
  },
  {
    year: "2026",
    title: "Memulai Pemrograman dengan Python",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Jan 2026", id: "Jan 2026" },
    expires: { en: "Expires Jan 2029", id: "Berlaku hingga Jan 2029" },
    credential: "72ZDKGEDVPYW",
    credentialUrl: "https://www.dicoding.com/certificates/72ZDKGEDVPYW",
  },
  {
    year: "2025",
    title: "Belajar Dasar Manajemen Proyek",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Oct 2025", id: "Okt 2025" },
    expires: { en: "Expires Oct 2028", id: "Berlaku hingga Okt 2028" },
    credential: "07Z6J7KMJXQR",
    credentialUrl: "https://www.dicoding.com/certificates/07Z6J7KMJXQR",
  },
  {
    year: "2025",
    title: "Financial Literacy 101",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Oct 2025", id: "Okt 2025" },
    expires: { en: "Expires Oct 2028", id: "Berlaku hingga Okt 2028" },
    credential: "JMZVVE1J3ZN9",
    credentialUrl: "https://www.dicoding.com/certificates/JMZVVE1J3ZN9",
  },
  {
    year: "2025",
    title: "Belajar Membuat Front-End Web untuk Pemula",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Jan 2025", id: "Jan 2025" },
    expires: { en: "Expires Jan 2028", id: "Berlaku hingga Jan 2028" },
    credential: "JLX19LE85P72",
    credentialUrl: "https://www.dicoding.com/certificates/JLX19LE85P72",
  },
  {
    year: "2025",
    title: "Belajar Membuat Aplikasi Web dengan React",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Jan 2025", id: "Jan 2025" },
    expires: { en: "Expires Jan 2028", id: "Berlaku hingga Jan 2028" },
    credential: "07Z63GEDMZQR",
    credentialUrl: "https://www.dicoding.com/certificates/07Z63GEDMZQR",
  },
  {
    year: "2025",
    title: "Belajar Dasar AI",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Jan 2025", id: "Jan 2025" },
    expires: { en: "Expires Jan 2028", id: "Berlaku hingga Jan 2028" },
    credential: "53XEDJMDYPRN",
    credentialUrl: "https://www.dicoding.com/certificates/53XEDJMDYPRN",
  },
  {
    year: "2024",
    title: "Fullstack Web Developer",
    issuer: "Binar Academy",
    initials: "BA",
    issued: { en: "May 2024", id: "Mei 2024" },
    credentialUrl:
      "https://storage.googleapis.com/binar-academy-prd/USERBATCH_1715578049_Certificate_zainalrtf%40gmail.com_-_Fullstack_Web_Development_-_41.pdf",
  },
  {
    year: "2023",
    title: "Product Management",
    issuer: "Binar Academy",
    initials: "BA",
    issued: { en: "Mar 2023", id: "Mar 2023" },
    credentialUrl:
      "https://drive.google.com/file/d/1fgViHZK-i89sScduQ1jYDl09iyGR2nt7/view?usp=share_link",
  },
  {
    year: "2022",
    title: "Belajar Prinsip Pemrograman SOLID",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Aug 2022", id: "Agu 2022" },
    expired: { en: "Expired Aug 2025", id: "Berakhir Agu 2025" },
    credential: "07Z6RMOVMPQR",
    credentialUrl: "https://www.dicoding.com/certificates/07Z6RMOVMPQR",
  },
  {
    year: "2022",
    title: "Belajar Membuat Aplikasi Flutter untuk Pemula",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Jan 2022", id: "Jan 2022" },
    credential: "ERZR4JE0NZYV",
    credentialUrl: "https://www.dicoding.com/certificates/ERZR4JE0NZYV",
  },
  {
    year: "2022",
    title: "Memulai Pemrograman Dengan Dart",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "Jan 2022", id: "Jan 2022" },
    credential: "2VX32MQGNPYQ",
    credentialUrl: "https://www.dicoding.com/certificates/2VX32MQGNPYQ",
  },
  {
    year: "2021",
    title: "Full-Stack Laravel Flutter 2021: Building E-Commerce and Chat Apps",
    issuer: "BuildWithAngga",
    initials: "BWA",
    issued: { en: "Oct 2021", id: "Okt 2021" },
    credential: "bKkG48GUAp",
    credentialUrl:
      "https://class.buildwithangga.com/certificate/full-stack-laravel-flutter-2021-building-e-commerce-and-chat-apps",
  },
  {
    year: "2021",
    title: "Mastering Android Development: Aplikasi Tiket Travel",
    issuer: "BuildWithAngga",
    initials: "BWA",
    issued: { en: "Aug 2021", id: "Agu 2021" },
    credential: "Q71d7QtTwT",
    credentialUrl:
      "https://class.buildwithangga.com/certificate/mastering-android-development-aplikasi-tiket-travel",
  },
  {
    year: "2021",
    title: "Dart & Flutter Development Bootcamp: Find House App",
    issuer: "BuildWithAngga",
    initials: "BWA",
    issued: { en: "Jun 2021", id: "Jun 2021" },
    credential: "dRvbAzfh2B",
    credentialUrl:
      "https://buildwithangga.com/storage/assets/certificates/bwa-certificate-flutter-apps-development-membuat-aplikasi-cari-kos-zainal-salamun.jpg",
  },
  {
    year: "2021",
    title: "Cloud Practitioner Essentials (Belajar Dasar AWS Cloud)",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "May 2021", id: "Mei 2021" },
    expired: { en: "Expired May 2024", id: "Berakhir Mei 2024" },
    credential: "6RPNK2WJRP2M",
    credentialUrl: "https://www.dicoding.com/certificates/6RPNK2WJRP2M",
  },
  {
    year: "2021",
    title: "Belajar Dasar Pemrograman JavaScript",
    issuer: "Dicoding Indonesia",
    initials: "DI",
    issued: { en: "May 2021", id: "Mei 2021" },
    expired: { en: "Expired May 2024", id: "Berakhir Mei 2024" },
    credential: "RVZK431LMPD5",
    credentialUrl: "https://www.dicoding.com/certificates/RVZK431LMPD5",
  },
  {
    year: "2021",
    title: "Android Developer Program Profesional Academy",
    issuer: "Digital Talent Scholarship",
    initials: "DTS",
    issued: { en: "Apr 2021", id: "Apr 2021" },
  },
  {
    year: "2016",
    title: "Microsoft Office Desktop Training",
    issuer: "Trust Training Partners",
    initials: "TTP",
    issued: { en: "Apr 2016", id: "Apr 2016" },
  },
];

const certificationGroups = certifications.reduce((groups, certificate) => {
  if (!groups[certificate.year]) groups[certificate.year] = [];
  groups[certificate.year].push(certificate);
  return groups;
}, {});

const certificationYears = [...new Set(certifications.map(({ year }) => year))];

function Certifications() {
  const { language, t } = useLanguage();

  return (
    <section className="certifications-section" aria-labelledby="certifications-title">
      <header className="certifications-header">
        <div>
          <span className="section-eyebrow">{t("certifications.eyebrow")}</span>
          <h2 id="certifications-title">{t("certifications.title")}</h2>
          <div className="certifications-summary" aria-label={t("certifications.summaryLabel")}>
            <span><strong>20</strong> {t("certifications.credentials")}</span>
            <span><strong>5</strong> {t("certifications.issuers")}</span>
            <span><strong>2016—2026</strong></span>
          </div>
        </div>

        <div className="certifications-intro">
          <p>{t("certifications.subtitle")}</p>
          <a
            href="https://www.linkedin.com/in/zainal-salamun-660a9598/details/certifications/"
            target="_blank"
            rel="noreferrer"
          >
            {t("certifications.viewLinkedIn")}
            <FiArrowUpRight aria-hidden="true" />
          </a>
        </div>
      </header>

      <div className="certification-years">
        {certificationYears.map((year) => (
          <section className="certification-year-group" key={year} aria-labelledby={`certification-year-${year}`}>
            <div className="certification-year-heading">
              <h3 id={`certification-year-${year}`}>{year}</h3>
              <span>
                {certificationGroups[year].length}{" "}
                {certificationGroups[year].length === 1
                  ? t("certifications.item")
                  : t("certifications.items")}
              </span>
            </div>

            <div className="certifications-grid">
              {certificationGroups[year].map((certificate) => (
                <article
                  className="certification-card"
                  key={`${certificate.issuer}-${certificate.title}`}
                >
                  <div className="certification-mark" aria-hidden="true">
                    <FiAward />
                    <span>{certificate.initials}</span>
                  </div>

                  <div className="certification-content">
                    <h4>{certificate.title}</h4>
                    <p>{certificate.issuer}</p>

                    <div className="certification-meta">
                      <span>{t("certifications.issued")} {certificate.issued[language]}</span>
                      {certificate.expires && <span>{certificate.expires[language]}</span>}
                      {certificate.expired && <span>{certificate.expired[language]}</span>}
                    </div>

                    {certificate.credential && (
                      <small>{t("certifications.credential")} {certificate.credential}</small>
                    )}

                    {certificate.credentialUrl && (
                      <a
                        className="certification-credential-link"
                        href={certificate.credentialUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("certifications.viewCredential")}
                        <FiArrowUpRight aria-hidden="true" />
                      </a>
                    )}
                  </div>
                </article>
              ))}
            </div>
          </section>
        ))}
      </div>
    </section>
  );
}

export default Certifications;
